import React from 'react'
import OrgUsersDisplay from '../popups/OrgUsersDisplay';
import { OrgAssociationType, Securables } from '../Enums';
import OnlyForRole from '../components/OnlyForRole';

const EmployeeManagementPage = () => {

  return <OnlyForRole role={Securables.organization_employee}><OrgUsersDisplay assocationType={OrgAssociationType.Employee} /></OnlyForRole>;
}

export default EmployeeManagementPage